module.exports = __webpack_public_path__ + "static/langojango-german-language-phrasebook-0d0f4daeb1ab87cde3e7ac271ec4dec3.png";